import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M6 19h4V5H6zm8-14v14h4V5z" /></g>,<defs key="1"></defs>,]
, 'CameraVideoPausex');
